import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button } from "reactstrap";

export default function CopyButton({
  text,
  container,
  showText,
  color = "active-light-primary",
  className = "btn-icon w-30px h-30px ms-auto ms-3",
}) {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <Button className={className} size="sm" color={color} onClick={copy}>
      <FontAwesomeIcon icon={copied ? "check" : "copy"}></FontAwesomeIcon>
      {container && showText ? (
        <>
          {" "}
          {copied
            ? container.localeManager.strings.ok
            : container.localeManager.strings.copy}
        </>
      ) : null}
    </Button>
  );
}
